export const radianToDegree = (radian: number): number =>
  radian * (180 / Math.PI);
export const degreeToRadian = (degree: number): number =>
  degree * (Math.PI / 180);

export const add = (
  vA: number[] = [],
  vB: number[] = [],
  v: number[] = []
): number[] => {
  if (!vA.length && !vB.length && vA.length !== vB.length) return v;
  for (let i = 0; i < vA.length; i++) {
    v = [...v, vA[i] + vB[i]];
  }
  return v;
};

export const subtract = (
  vA: number[] = [],
  vB: number[] = [],
  v: number[] = []
): number[] => {
  if (!vA.length && !vB.length && vA.length !== vB.length) return v;
  for (let i = 0; i < vA.length; i++) {
    v = [...v, vA[i] - vB[i]];
  }
  return v;
};

export const scalar = (n = 0, v: number[] = []): number[] => {
  if (!v.length) return v;
  for (let i = 0; i < v.length; i++) {
    v[i] = n * v[i];
  }
  return v;
};

export const square = (n: number): number => n * n;

export const magnitude = (v: number[] = [], n = 0): number => {
  if (!v.length) return n;
  for (let i = 0; i < v.length; i++) {
    n += square(v[i]);
  }
  return Math.sqrt(n);
};

export const normalisation = (v: number[] = []): number[] => {
  if (!v.length) return v;
  v = scalar(1 / magnitude(v), v);
  return v;
};

export const dot = (vA: number[] = [], vB: number[] = [], d = 0): number => {
  if (!vA.length || !vB.length || vA.length !== vB.length) return d;
  for (let i = 0; i < vA.length; i++) {
    d += vA[i] * vB[i];
  }
  return d;
};

export const theta = (vA: number[] = [], vB: number[] = []): number => {
  if (!vA.length || !vB.length || vA.length !== vB.length) return NaN;
  const r = Math.acos(dot(vA, vB) / (magnitude(vA) * magnitude(vB)));
  return isNaN(r) ? NaN : r;
};
